import React from "react";
import { NumberInput } from "@jsq/ds/core";
import {
  INTEGER_FIELD_MAX_VALUE,
  INTEGER_FIELD_MIN_VALUE,
} from "../../../utils/extensionFieldUtils";
import { createFieldPlaceholder, handleNumberInputWheel } from "./utils";
import type { FieldEditorProps } from "./types";

/**
 * Integer Field Editor Component
 *
 * Specialized input component for integer extension fields.
 * Provides number input with integer validation and design system styling.
 */
export const IntegerFieldEditor: React.FC<FieldEditorProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const handleSetValue = (newValue: string) => {
    onChange(newValue);
  };

  return (
    <NumberInput
      value={value}
      onChange={handleChange}
      onSetValue={handleSetValue}
      onWheel={handleNumberInputWheel}
      placeholder={createFieldPlaceholder(field)}
      disabled={disabled}
      errorMessage={error || undefined}
      isFullWidth
      step={1}
      min={INTEGER_FIELD_MIN_VALUE}
      max={INTEGER_FIELD_MAX_VALUE}
      data-testid="integer-field-editor"
    />
  );
};

export default IntegerFieldEditor;
